import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import IoTDashboard from './components/IoTDashboard';
import NetworkDiscovery from './components/NetworkDiscovery';
import DatabaseExplorer from './components/DatabaseExplorer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="app-nav">
          <Link to="/">Weather</Link>
          <Link to="/iot">ThePoint</Link>
          <Link to="/rumsey">Rumsey</Link>
          <Link to="/network">Network</Link>
          <Link to="/database">Database</Link>
        </nav>
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/iot" element={<IoTDashboard location="thepoint" />} />
            <Route path="/rumsey" element={<IoTDashboard location="rumsey" />} />
            <Route path="/network" element={<NetworkDiscovery />} />
            <Route path="/database" element={<DatabaseExplorer />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;

// Cache bust 1770327157
